import React from 'react';
import { Currency as CompanyCurrency } from 'src/views/settings/company-settings/currency/company-currency';
import { Currency as CompanyCurrencyTemplates } from 'src/views/settings/company-settings/currency/currency';
import { FeatureFlags } from '@oliasoft/feature-flags';
import { FeatureFlagName } from 'src/enums/feature-flags';

export const CurrencyWrapper = () => {
  const isProjectCurrencySettingsActive = FeatureFlags.isActive(FeatureFlagName.UserSetCurrency);
  return isProjectCurrencySettingsActive ? <CompanyCurrencyTemplates /> : <CompanyCurrency />;
};
